export const version = '0.389.0'
export const chameleonWebVersion = '0.0.0-snapshot-20230606150531'
